import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getWorkDays } from "./Axios";

const WorkDaySelect = props => {
  const [work_days, setWorkDays] = useState([]);

  const handleChange = selectedOption => {
    props.handleChange(selectedOption, "work_day");
  };

  useEffect(() => {
    getWorkDays((response) => {
      if (response && response.data) {
        const newWorkDays = response.data.map((work_day) => ({
          value: work_day.id,
          label: work_day.name,
          uniqueIdentifier: work_day.unique_identifier,
        }));
        setWorkDays(newWorkDays);
      }
    });
  }, []);

  return (
    <Select
      inputId="trabajando-work-day-search"
      onChange={handleChange}
      options={work_days}
      placeholder="Buscar y seleccionar jornada laboral"
      value={
        work_days.find(
          (option) => option.value === props.value?.value
        ) || null
      }
      getOptionLabel={(e) => `${e.label}`}
      filterOption={(option, input) => {
        const searchTerm = input.toLowerCase();
        const { label } = option.data;
        return (
          label.toLowerCase().includes(searchTerm)
        );
      }}
      isSearchable={true}
    />
  );
};

export default WorkDaySelect;

